import {handleActions} from 'redux-actions';
import {Record, List, fromJS} from 'immutable';

import * as Actions from './actions';

const ReportState = Record({
    fetching: true,
    selectedParentTab: null,
    selectedEmployeeTab: null,
    activeChildren: 0,
    activeEmployees: 0,
    totalChildren: 0,
    totalEmployees: 0,
    childrenWithoutLogin: List(),
    inactiveChildren: List(),
    bouncedRelations: List(),
    employeesWithoutLogin: List(),
    inactiveEmployees: List(),
    bouncedEmployees: List(),
});

export default handleActions(
    {
        [Actions.fetchReport.type]: state =>
            state.merge({
                fetching: true,
            }),
        [Actions.fetchReportFailed.type]: () =>
            new ReportState({
                fetching: false,
            }),
        [Actions.fetchReportSuccess.type]: (state, {payload}) =>
            state.merge(
                fromJS({
                    fetching: false,
                    activeChildren: payload.response.activeChildren,
                    activeEmployees: payload.response.activeEmployees,
                    totalChildren: payload.response.totalChildren,
                    totalEmployees: payload.response.totalEmployees,
                    childrenWithoutLogin: payload.response.childrenWithoutLogin,
                    inactiveChildren: payload.response.inactiveChildren,
                    bouncedRelations: payload.response.bouncedRelations,
                    employeesWithoutLogin: payload.response.employeesWithoutLogin,
                    inactiveEmployees: payload.response.inactiveEmployees,
                    bouncedEmployees: payload.response.bouncedEmployees,
                }),
            ),
        [Actions.setParentTab.type]: (state, {payload}) =>
            state.merge({
                selectedParentTab: state.selectedParentTab === payload.tabId ? null : payload.tabId,
            }),
        [Actions.setEmployeeTab.type]: (state, {payload}) =>
            state.merge({
                selectedEmployeeTab: state.selectedEmployeeTab === payload.tabId ? null : payload.tabId,
            }),
    },
    new ReportState(),
);
